import { hotComments } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

export default function Reviews() {
  return (
    <section id="review" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center">
          <SectionHeading
            center
            kicker="评论区神评精选 · 神评热榜"
            title="每一条高赞神评，都值得单独一席"
            desc="我们不只搬运评论，还把最扎心、最上头的高赞神评单独挑出来，让好句子不被长楼淹没。"
          />

          <div className="relative mt-10 w-full max-w-4xl">
            {/* 中间主线 */}
            <span className="absolute left-5 top-2 bottom-2 w-px bg-primary-200 md:left-1/2"></span>
            <div className="space-y-6">
              {hotComments.map((c, idx) => (
                <article
                  key={c.id}
                  className={`relative flex items-start gap-4 ${
                    idx % 2 === 0 ? "md:justify-start" : "md:justify-end"
                  }`}
                >
                  <span
                    className={`absolute left-5 top-6 z-10 hidden h-3 w-3 -translate-x-1/2 rounded-full border-2 border-background-100 bg-accent-500 md:block ${
                      idx % 2 === 0 ? "md:left-1/2" : "md:left-1/2"
                    }`}
                  ></span>
                  <div
                    className={`ml-12 w-full rounded-2xl border border-background-200 bg-background-50 p-5 md:ml-0 md:w-[46%] ${
                      idx % 2 === 0 ? "" : ""
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-sm font-semibold text-primary-800">
                        {c.author.charAt(0)}
                      </span>
                      <div className="min-w-0">
                        <p className="truncate text-sm font-medium text-foreground-800">{c.author}</p>
                        <p className="flex items-center gap-1 truncate text-xs text-foreground-500">
                          <i className="ri-quill-pen-line"></i>
                          神评 · {c.post}
                        </p>
                      </div>
                    </div>
                    <p className="mt-3 text-[15px] leading-relaxed text-foreground-800">{c.text}</p>
                    <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap text-accent-500">
                        <i className="ri-heart-fill"></i>
                        {c.likes.toLocaleString()}
                      </span>
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-reply-line"></i>
                        {c.repliesCount}
                      </span>
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-time-line"></i>
                        {c.time}
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}